// ── Email fields: force lowercase ───────────────────────────────────────────
// FairMate stores and compares account emails/usernames in lowercase, but
// mobile keyboards auto-capitalize the first letter and users type mixed
// case. Without normalization "Foo@bar.de" fails login against the stored
// "foo@bar.de", and email/email_again comparisons mismatch on case alone.
// So every e-mail input is lowercased as soon as the user leaves the field
// (change/blur) — before any submit or comparison runs.
//
// Port of the inline jQuery block ("Alle e-Mail-Feld-Eingaben immer klein
// setzen nach Eingabe"). Delegated on document (change bubbles, focusout =
// bubbling blur) so fields mounted later by ShopNG/RegiNA widgets are
// covered too.
(function () {
    'use strict';

    var SELECTOR = [
        'input#login_username',
        'input#username_login',
        'input#username_newpwd',
        'input#user_s_email',
        'input#ctrl_s_email2',
        'input[name=email]',
        'input[name=email_again]'
    ].join(',');

    function lowercase(e) {
        var field = e.target;
        if (!field || !field.matches || !field.matches(SELECTOR)) return;
        var email = field.value;
        var lower = email.toLowerCase();
        if (lower !== email) field.value = lower;
    }

    document.addEventListener('change', lowercase);
    document.addEventListener('focusout', lowercase);
})();
